import InputDropdown from "./inputDropdown";
import InternalInput from "./internalInput";

const Input = InternalInput;
Input.Dropdown = InputDropdown;

export default Input;